module.exports = __webpack_public_path__ + "img/18.1e99069c.jpg";